import {React, clickOn, _n, _s} from 'pexui';
import {Button} from './uicomps';
import {FaqHelpLink} from './faq';

export const PageFooter = ({visible, buttons, hasHelp}) => {
    if(visible){
     
        let buttonSize = "col-xs-12 col-md-4";
        let firstButtonOffset = buttons.length <= 1? ' col-md-offset-8': 
            (buttons.length === 2? ' col-md-offset-4': '');
        if(buttons.length === 1 && (buttons[0].className === 'infw-btn-primary' || buttons[0].className === 'infw-btn-secondary')){
            firstButtonOffset = ' col-md-offset-6';
            buttonSize = "col-xs-12 col-md-6";
        }

        return <div className="infw-footer">
            <div className="infw-footer-help">
                {hasHelp?
                    <FaqHelpLink id="infw_link_help"/>: ''
                }
            </div>
            <div className="infw-footer-buttons">
                { buttons.map((button,index) => (
                    <div>
                        <Button
                            id={button.id}
                            label={button.label}                            
                            className={(button.className || (button.isPrimary? "infw-btn-primary-small": "infw-btn-secondary-small")) + ' margin-1'}
                            disabled={button.disabled?true:false}
                            busyZone={button.busyZone}
                            onClick={button.onClick}/>
                    </div>
                    ))
                }
            </div>
        </div>;
    }else{
        return '';
    }
}



// WEBPACK FOOTER //
// ./application/src/views/comps/footer.jsx